<template>
    <div class="rates__grid">
        <div class="lvl-1">
            <template v-for="(rate, index) in get_rates">
                <template v-if="index < 4">
                    <div class="department" :key="rate._id" @click="open_department_modal(rate)">
                        <div class="department__statuses">
                            <div>
                                <img src="/images/rates/ants/bad.svg" />
                                <span class="color-blue">{{ get_percent(rate.to_rates, 'low') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/good.svg" />
                                <span class="color-yellow">{{ get_percent(rate.to_rates, 'middle') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/cool.svg" />
                                <span class="color-green">{{ get_percent(rate.to_rates, 'high') }}</span>
                            </div>
                        </div>
                        <div class="department__name">{{ rate.name }}</div>
                    </div>
                </template>
            </template>
        </div>
        <div class="lvl-2">
            <template v-for="(rate, index) in get_rates">
                <template v-if="index > 3 && index < 9">
                    <div class="department" :key="rate._id" @click="open_department_modal(rate)">
                        <div class="department__statuses">
                            <div>
                                <img src="/images/rates/ants/bad.svg" />
                                <span class="color-blue">{{ get_percent(rate.to_rates, 'low') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/good.svg" />
                                <span class="color-yellow">{{ get_percent(rate.to_rates, 'middle') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/cool.svg" />
                                <span class="color-green">{{ get_percent(rate.to_rates, 'high') }}</span>
                            </div>
                        </div>
                        <div class="department__name">{{ rate.name }}</div>
                    </div>
                </template>
            </template>
        </div>

        <div class="lvl-3">
            <template v-for="(rate, index) in get_rates">
                <template v-if="index > 8 && index < 14">
                    <div class="department" :key="rate._id" @click="open_department_modal(rate)">
                        <div class="department__statuses">
                            <div>
                                <img src="/images/rates/ants/bad.svg" />
                                <span class="color-blue">{{ get_percent(rate.to_rates, 'low') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/good.svg" />
                                <span class="color-yellow">{{ get_percent(rate.to_rates, 'middle') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/cool.svg" />
                                <span class="color-green">{{ get_percent(rate.to_rates, 'high') }}</span>
                            </div>
                        </div>
                        <div class="department__name">{{ rate.name }}</div>
                    </div>
                </template>
            </template>
        </div>

        <div class="lvl-4">
            <template v-for="(rate, index) in get_rates">
                <template v-if="index > 13">
                    <div class="department" :key="rate._id" @click="open_department_modal(rate)">
                        <div class="department__statuses">
                            <div>
                                <img src="/images/rates/ants/bad.svg" />
                                <span class="color-blue">{{ get_percent(rate.to_rates, 'low') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/good.svg" />
                                <span class="color-yellow">{{ get_percent(rate.to_rates, 'middle') }}</span>
                            </div>
                            <div>
                                <img src="/images/rates/ants/cool.svg" />
                                <span class="color-green">{{ get_percent(rate.to_rates, 'high') }}</span>
                            </div>
                        </div>
                        <div class="department__name">{{ rate.name }}</div>
                    </div>
                </template>
            </template>
        </div>
        <NewDepartmentRate
            :dialog="dialog"
            :department="prop_department"
            :before_sended="before_sended"
            @close_modal="on_close_modal"
            @edit_before_send="on_edit_before_send"
        ></NewDepartmentRate>
    </div>
</template>

<script>
import NewDepartmentRate from './modals/NewDepartmentRate.vue'

import { mapGetters } from 'vuex'

export default {
    name: 'Products',
    data: () => ({
        group: false,
        group_name: null,
        dialog: false,
        before_sended: true,
        prop_department: {},
    }),
    components: {
        NewDepartmentRate,
    },

    computed: {
        ...mapGetters(['get_rates']),
    },
    methods: {
        get_percent(rates, type) {
            let x = []

            switch (type) {
                case 'low':
                    x = rates.filter((rate) => rate.rate == '1')
                    break
                case 'middle':
                    x = rates.filter((rate) => rate.rate == '2')
                    break
                case 'high':
                    x = rates.filter((rate) => rate.rate == '3')
                    break

                default:
                    break
            }

            if (x.length == 0) return `0 %`
            return ` ${((x.length / rates.length) * 100).toFixed()} %`
        },
        open_department_modal(rate) {
            this.prop_department = rate
            this.dialog = true
        },
        on_close_modal(value) {
            this.dialog = value
            this.before_sended = true
        },

        on_edit_before_send(value){
            this.before_sended = value
        }
    },
}
</script>

<style scoped>
.rates__grid {
    width: 1218px;
    margin: 20px auto;
}

.lvl-1,
.lvl-2,
.lvl-3,
.lvl-4 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    width: 1218px;
}

.lvl-1 .department {
    width: 296px;
    height: 210px;
}

.lvl-2 .department {
    width: 235px;
    height: 200px;
}

.lvl-3 .department {
    width: 223px;
    height: 180px;
}

.lvl-3 .department .department__name,
.lvl-4 .department .department__name {
    font-size: 18px;
}

.lvl-3 .department:nth-child(3) {
    width: 282px;
    height: 180px;
}

.lvl-4 .department {
    width: 194px;
    height: 182px;
}

.department {
    display: flex;
    background: #ffffff;
    border-radius: 30px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.department__statuses {
    display: flex;
    width: 150px;
    justify-content: space-between;
    margin-bottom: 10px;
}

.department__statuses div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
}

.department__statuses div img {
    height: 36px;
    margin-bottom: 8px;
}

.department__name {
    font-size: 22px;
}

.color-blue {
    color: #284b99;
}

.color-yellow {
    color: #faaf50;
}

.color-green {
    color: #65b337;
}
</style>